import React from 'react';
import { useParams } from 'react-router-dom';
import ImageSlider from '../pages/ImageSlider'; // Assurez-vous que le chemin est correct
import './ServiceDetail.css';

const services = [
  { id: 1, title: 'Nettoyage de Fin de Chantier ',
    description: `Nos services de nettoyage de fin de chantier incluent :
    - Nettoyage des sols : Aspiration, lavage et lustrage des sols, y compris les sols en marbre, carrelage, parquet, etc.
    - Nettoyage des murs : Lessivage des murs, dépoussiérage des plinthes et des moulures.
    - Nettoyage des vitres : Nettoyage intérieur et extérieur des fenêtres, portes-fenêtres et baies vitrées.
    - Nettoyage des sanitaires : Nettoyage et désinfection des toilettes, lavabos, douches et baignoires.
    - Nettoyage des menuiseries : Nettoyage des portes, fenêtres, placards et autres menuiseries.
    - Enlèvement des gravats et déchets : Enlèvement des gravats, poussières et déchets de chantier.
    - La remise en état des sols : Ils font l’objet d’un nettoyage en profondeur à l’aide de monobrosse, d’autolaveuses ou par lavage humide.
    - Vitres : Le nettoyage, le grattage, le dégraissage et le lustrage méticuleux des parties vitrées.
    - Cristallisation des sols en marbres et/ou en pierre.
    - Décapage des sols et métallisation.
    - Ponçage et vitrification du parquet.
    - L’aspiration, la mise en propreté des conduits d’aération qui ont pu être bouchés par les particules de plâtre, de ciment ou encore de bois.
    - L’aération du bâtiment, l’évacuation des odeurs de matériaux, la désinfection de l’air.
    - L’élimination et le retrait des éléments résiduels du travail des ouvriers (gravats, pierre, ciment, traces de colles, chutes de bois ou de PVC…).
    - Dépoussiérage.
    - Lavage des surfaces.
    - Nettoyage de mobilier.
    - Grattage et dégraissage des colles, résines, ciments et peintures sur le sol et les murs.
    - Nettoyage, Lavage des Portes et des Poignées de portes.
    - Nettoyage des plinthes.

    Nos équipes de nettoyage sont spécialisées dans le nettoyage après construction et de fin de chantier. Elles sont formées pour garantir un travail de qualité irréprochable, même pour les clients les plus exigeants.

    Bio Cleaners Services s'engage à vous fournir :

    - Un devis gratuit et personnalisé.
    - Un travail effectué dans les délais impartis.
    - Un service client de qualité.`,
    images: ['/service1.jpeg'] 
    },
  { id: 2, title: 'Nettoyage d’hôpitaux, cliniques',
   description:
    `Le secteur de la santé évolue dans un contexte reglementaire et budgétaire de plus en plus contraignant. Les établissements de santé (hopitaux, cliniques) doivent jongler entre les ressources disponnibles, les besoins de leurs patients ou residents et les attentes de leur personel. Bio Cleaners Services vous propose une gammme complète de prestations pour vous accompagner dans ces defis:

Ameliorer le confort de vos patients, residants et de vos salariés

Un environement propre et sain: Nos equipes s'assurrent du nettoyage et de la désinfection rigoureux de tous les espaces, contribuant ainsi à la prevention des infections et à la réduction des risques de contamination.

Un service attentifonné: Nous sommes concients que le bien-etre des patients et des residents est au coeur de vos preocupations. C'est pourquoi nous mettons l'accent sur l'ecoute et la beinveillance dans nos interventions.

Un personel qualifié et discret: Nos agents sont formés aux exigences specifiques du secteur de la santé et interviennent en toute discrétion pour respecter la tranquillité de vos patients et résidents.

*Un environement professionel et aceuillant: La propreté et l'hygiene sont des élements clés pour l'image de votre établissement. En confiant la propreté de vos locaux à Bio Cleaners Services, vous vous assurrez d'offrir à vos patients, résidents et visiteurs un environement professionel et aceuillant.

*Une communication transparante: Nous mettons à votre disposition un suivi personalisé de nos interventions et vous garantisons un niveau de qualité constant.

*Optimiser vos coûts de fonctionnement:

-Des solutions sur mesurs: Nous adaptons nos services à vos besoins specifiques et vous proposons des solutions tarifaires compétitives.

-Un personel flexible: Nos équipes sont disponnibles 7j/7 et 24h/24 pour répondre à vos besoins ponctuels ou récurrents.

-Une optimisation des ressources: En externalisant la gestion de la propreté de vos locaux, vous pouvez vous concentrer sur votre coeur de métier et réaliser des économies substancielles. Bio Cleaners Services: Votre partenaire pour un environnement sain et agréable dans le secteur de la santé.

-Nettoyage et entretien
-Préparation et service des repas
-Lingerie
-Gestion des déchets
-Espaces verts et décoration florale`,
    images: ['/hopi.jpg','/hopi2.jpg ','/lithopi.jpg'] 
    },
  { id: 3, title: 'Jardinier d’espaces verts',
    description: 
    `
Des espaces verts bien entretenus sont un élément déterminant pour l'image de votre entreprise. Parcs, terrasses et jardins contribuent à la perception de votre organisation et ont un impact important sur vos collaborateurs et vos clients. Confiez à Bio Cleaners Services l'aménagement et l'entretien de vos espaces verts et donnez à vos locaux l'apparence qu'ils méritent.

Bio Cleaners Services : Votre partenaire pour des extérieurs harmonieux.

Notre équipe d'experts en aménagement paysager travaille en étroite collaboration avec vous pour déterminer l'aménagement qui correspond le mieux à vos besoins et à vos objectifs. Que vous souhaitiez adoucir l'aspect d'un bâtiment, renforcer la convivialité de vos espaces, créer un parcours de promenade ou simplement entretenir vos jardins, nous concevons une solution sur-mesure pour répondre à vos attentes.

Notre expertise s'étend à une large gamme de projets, des plus classiques aux plus audacieux. Nous sommes spécialisés dans la transformation de petits espaces en oasis de verdure au cœur de vos bâtiments. Ces lieux procurent un impact visuel saisissant et contribuent au bien-être de vos collaborateurs.

Bio Cleaners Services vous propose une large gamme de services d'aménagement paysager :

-Création d'allées, bosquets, taillis et parterres de fleurs.
-Réalisation de murets.
-Pose de grillage.
-Installation et maintenance de systèmes d'arrosage.
-Création de terrasses et de jardins d'agrément.
-Massifs de fleurs
-Plantation et entretien d'arbres fruitiers 
-Gazon
-Pose de terrasses en bois et teck 


Bio Cleaners Services s'adapte à vos objectifs et à votre activité pour vous proposer un aménagement sur-mesure. Nous tenons compte de votre budget et de vos préférences pour créer des espaces verts qui s'harmonisent parfaitement avec votre environnement.`,
    images: ['/jardinage.jpg', '/jar.jpg'] 
    },
  { id: 4, title: 'Nettoyage industriel',
    description:
    `
Nettoyage, remise en état des sols usines et entrepôts.

Quelle que soit la nature des revêtements, les techniciens sont formés pour appliquer un traitement spécifique visant à nettoyer, décaper, dégraisser et faire briller votre sol sans le rendre glissant. En fonction de l’état des sols, Bio Cleaners Services vous propose une prestation de remise en état en utilisant des machines dédiées au nettoyage industriel : nettoyage haute- pression, décapage des sols, nettoyage des surfaces à l’auto-laveuse, shampouineuse moquette, rénovation des sols à la monobrosse…

Les techniciens de surface Bio Cleaners Services peuvent également prendre en charge le retrait des différents déchets : copeaux, papiers, etc.

Nos méthodologies d’intervention garantissent le respect des normes en vigueur pour votre secteur d’activité : industrie agroalimentaire, pharmaceutique, entrepôt, usine de bois et bien d’autres encore. Nos agents d’entretien sont régulièrement formés aux techniques de nettoyage et à la connaissance des infrastructures industrielles afin d’assurer des prestations de qualité pour préserver l’environnement de travail.

Nettoyage et désinfection des machines de production.

L’entretien et le nettoyage des équipements industriels comme les machines de production sont indispensables pour éviter tout risque de panne ou d’accident. Dans certains cas, les poussières produites par les machines industrielles peuvent être sources de maladies professionnelles pour les collaborateurs et de diminution de performances pour les équipements.

Dans le souci du respect de l’environnement et du bien-être des collaborateurs, notre société industrielle Bio Cleaners Services a mis en place une réelle politique de nettoyage industriel avec :

-un nettoyage efficace et fiable. 

-Nos techniciens sont à votre disposition pour la désinfection de vos machines de production comme il se doit.

Nettoyage quotidien des sites industriels:

Outre les sols et les machines de production, notre équipe prend en charge des nettoyages complémentaires selon vos besoins.

Nettoyage et entretien des bureaux:

Si les bureaux sont présents au sein de l’usine ou de l’entrepôt, nos agents d’entretien vous proposent le nettoyage, l’entretien et la désinfection de vos locaux professionnels : 

mobiliers, postes de travail, sols et murs, sortie des poubelles et bien d’autres encore selon vos attentes.

Nettoyage et désinfections des chambres froides:

Ces pièces frigorifiques qui permettent de conserver les aliments, par le maintien du froid ou la congélation, nécessitent un entretien méticuleux, avec un nettoyage et une désinfection méthodiques

Nettoyage et entretien des salles de pause, sanitaires:

Bien entendu, Bio Cleaners Services réalise également l’entretien des salles de pause et des

sanitaires pour garantir un environnement de travail sain et agréable.

*Nettoyage des cérémonies (mariage, cocktail, réception...) 

*Nettoyage de salles (concert, théâtre...) 

*Nettoyage après soirée .

*Nettoyage des congrès, conférence, salon professionnel... 

*Nettoyage des fêtes d’ouverture. 



.`,
    images: ['/netoyage industrielle.jpg'] 
    },
  { id: 5, title: 'Nettoyage des vitres',
    description:`
Vitres propres, image professionnelle : Bio Cleaners Services à votre service.
Dans les commerces, la propreté et l'attractivité des vitrines sont essentielles pour :

*Attirer les clients

*Mettre en valeur vos produits et services

*Inspirer confiance à vos clients

Bio Cleaners Services est une entreprise spécialisée dans le nettoyage de vitres pour les commerces, les maisons, les immeubles institutionnels et les bâtiments industriels.

Nous offrons une large gamme de services, notamment :

*Nettoyage de vitrerie dans les commerces .

*L'entretien régulier de fenêtres .

*Le lavage de vitres en hauteur .

*Lavage des vitres intérieures et extérieures.

*Lavage des vitrines .

*Lavage des miroirs . 

*Nettoyage des encadrements de fenêtres

*Nettoyage des stores.

Nos techniciens sont formés et équipés pour :

-Nettoyer vos vitres rapidement et efficacement.

-Éliminer toutes les traces de saleté, de poussière et de graisse

-Laisser vos vitres impeccables et brillantes .

Nous utilisons des produits et des méthodes :

*Efficaces et sans danger pour la santé.

*Respectueux de l'environnement.

*Adaptés à chaque type de vitre.

N'hésitez pas à nous contacter pour obtenir un devis gratuit.
    .`,
    images: ['/vt.jpg','/zaj.jpg'] 
    },
  { id: 6, title: ' Optimisez la production d énergie de vos panneaux solaires:',
    description: `
Bio Cleaners Services, société spécialisée dans le nettoyage professionnel, propose un service d'entretien performant pour vos panneaux photovoltaïques. 
Grâce à un dispositif adapté et des techniques éprouvées, nous garantissons un nettoyage optimal qui maximise la production d'énergie de votre installation solaire.

Pourquoi faire appel à Bio Cleaners Services pour le nettoyage de vos panneaux solaires ?

Pour le particulier comme pour le professionnel, un nettoyage régulier offre des avantages considérables :

Production d'énergie accrue: La saleté et les résidus qui s'accumulent sur vos panneaux solaires peuvent réduire leur rendement énergétique jusqu'à 30%. Un nettoyage professionnel par Bio Cleaners Services permet d'éliminer ces obstacles et de retrouver une production d'énergie optimale.

Rentabilité à long terme: En augmentant la production d'énergie de vos panneaux, vous réalisez des économies substantielles sur vos factures d'électricité.

Prolongation de la durée de vie: Un entretien régulier permet de préserver vos panneaux solaires et d'en prolonger la durée de vie, évitant ainsi un remplacement précoce et coûteux.

Valorisation de votre patrimoine: Des panneaux solaires propres et bien entretenus augmentent la valeur de votre propriété, que ce soit une résidence ou un bâtiment professionnel.

Bio Cleaners Services s'engage à:

Utiliser des techniques de nettoyage adaptées et performantes.

Déployer des techniciens expérimentés et formés aux spécificités des panneaux solaires.

Assurer le respect des normes de sécurité les plus strictes.

Optimisez la performance de votre installation solaire et réduisez vos factures d'énergie. Contactez Bio Cleaners Services dès aujourd'hui pour un nettoyage professionnel de vos panneaux solaires !

*La satisfaction de voir son objectif financier atteint.

*La protection de son installation solaire assurée, sans risque électrique.

*L’assurance d’une productivité à 100% garantie.`,
    images: ['/nettoyage panneu .jpg', '/pano.jpg'] 
    },
  { id: 7, title: 'Service de ponçage et cristallisation du marbre:',
    description: `

    Nos experts du nettoyage interviennent rapidement pour entretenir et rénover vos sols en marbre. Dans les halls d’immeuble, bureau, maison, les sols en marbre connaissent un franc succès grâce à leur touche d’authenticité et de luxe. Cependant, pour garder un sol en marbre en bon état, il faut en prendre.

    -Ponçage:
    
    Cette opération consiste à griffer la surface de la pierre pour enlever toutes les irrégularités qui l’empêchent d’être lisse. Concrètement, le ponçage est un remède qui intervient suite à un mauvais entretien du marbre. Le ponçage du marbre fait également suite à une opération de rénovation. Lorsque les tâches sont profondément ancrées dans le marbre et que celui-ci perd tout son éclat, une réparation s’impose. Dans ces cas précis, il s’agit non seulement de reboucher les fissures du marbre, mais également d’uniformiser la surface de nouveau.
    
    -Cristalliser:
    
    Cette étape consiste à provoquer une réaction mécano-chimique afin de rendre son éclat naturel au marbre. La cristallisation est aussi indispensable pour rendre le marbre moins sensible aux rayures et aux chocs. Cette opération s’effectue essentiellement avec un produit spécifique cristallisant et une mono brosse pourvue d’une lame en acier. À l’issue d’une opération de cristallisation, on passe au lustrage et au polissage final du marbre au sol ou sur le mobilier.
    
    -Service de ponçage et vitrification des parquets:
    
    Bio Cleaners Services propose du ponçage, de la vitrification et de la mise en cire à l’ancienne. L’équipe met à votre disposition le savoir-faire et l’expertise de techniciens qualifiés en ponçage et en vitrification de parquets. Lustrer, rénover, frotter, essuyer, rincer, détacher, décaper, huiler, cirer, dépoussiérer, ces actions de nettoyage n’ont aucun secret pour nos agents d’entretien respectueux et expérimentés. Pour un entretien courant et régulier, faites appel à nos professionnels du nettoyage.
    
    -Un ponçage qui sera une véritable rénovation du marbre.
    
    -Un polissage de travertin qui effacera les tâches, rayures superficielles et donnera de la brillance.
    
    -Une cristallisation de marbre qui donnera de la brillance à la pierre.`,
    images: [ '/marbre-cristallisation.jpg'] 
    },
  { id: 8, title: 'Nettoyer les locaux de l’école',
    description:  `
   Les locaux scolaires tels que les salles de classe, les bureaux administratifs, la cantine et La cuisine, les espaces dédiés aux professeurs, les salles d'étude, les laboratoires, les voies de circulation (escaliers, couloirs, parvis, cour) sont des lieux à forte fréquentation. Cette promiscuité favorise la propagation des germes et des bactéries, ce qui peut mettre en danger la santé des élèves et du personnel.

Bio Cleaners Services est une entreprise spécialisée dans le nettoyage et la désinfection des locaux scolaires. Nous utilisons des techniques, produits et méthodes adaptées pour garantir un environnement sain et propre.

Nos services incluent :

Nettoyage et désinfection des sols, murs, plafonds et surfaces.

Désinfection des sanitaires et des points de contact.

Traitement des odeurs et des moisissures.

Nettoyage des vitres et des moquettes.

Entretien des espaces verts.

Bio Cleaners Services est une entreprise fiable et expérimentée. Nous sommes agréés par le ministère de la Santé et nous disposons d'une équipe de professionnels formés et équipés pour répondre à vos besoins.

Nous intervenons dans tous types d'établissements scolaires :

-Écoles maternelles et primaires.

-Collèges et lycées.

-Universités.

N'hésitez pas à nous contacter pour obtenir un devis gratuit.

Libérer du temps pour s’occuper des enfants.

*Garantir une hygiène parfaite.

*Entretenir la confiance.

*Préserver la santé des personnes et respecter l’environnement.`,
    images: ['/ecole.jpg'] 
    },

  { id: 9, title: 'INDUSTRIE AGRO-ALIMENTAIRE:',
    description:  `
Des réglementations renforcées, une concurrence rude et des consommateurs toujours plus exigeants…
En milieu agroalimentaire, l’innovation des process de production est aujourd’hui indispensable pour optimiser les coûts et gagner en compétitivité. Plus que jamais, les professionnels du secteur doivent se concentrer sur leur cœur de métier pour relever ce challenge quotidien. 

Notre ambition est de vous accompagner durablement dans cette perpétuelle recherche de performance en vous assurant, chaque jour, une utilisation optimale de votre site de production. 

Nos Agents réalisent leurs prestations dans le seul souci de vous garantir l’hygiène et la fiabilité de vos installations de production en matière de sécurité alimentaire et d'offrir à vos collaborateurs un environnement sain et agréable au quotidien. 

*Le rinçage à l’eau potable froide pour enlever les traces et les résidus des désinfectants.

*Le grattage et raclage des surfaces sales.

*Le prélavage au jet d’eau froid ou chaud pour les graisses.

*Les salissures apportées par les outils ou machines utilisés. 

*Les contaminations et infections d’origine microbiologique et chimique.
        .`,
    images: ['/netoyage industrie agroaliment.jpg', '/aga.jpg'] 
    },
  { id: 10, title: 'Nettoyage des copropriété',
    description:
 `

L'entreprise Bio Cleaners Services est à votre service pour l’entretien d'immeubles et de copropriétés à Agadir , Marrakech et Casablanca. 

Votre devis d'entretien d'immeuble ou copropriété vous sera envoyé sous 24h après visite des locaux et proposition d'un cahier des charges. L'entretien de copropriétés peut comprendre les tâches suivantes:

*Balayage et lavage des parties communes..

*Dépoussiérage des plinthes, boiseries, bordures et bords de fenêtres.

*Nettoyage du digicode et de l'interphone, des boîtes aux lettres.

*Lavage et désinfection du local poubelles et des conteneurs.

Nous proposons en complément du nettoyage courant de copropriétés le nettoyage des moquettes et le traitement des sols. Nous sommes à votre service pour le nettoyage après travaux dans les immeubles.`,
    images: ['/copropriete.jpg', '/corporité.jpg'] 
    },
  { id: 11, title: 'Nettoyage événementiel',
    description:  `
    Notre équipe expérimentée et professionnelle s'assurera que votre événement se déroule dans un environnement propre et impeccable.

    Nous offrons une large gamme de services, notamment :
    
    *Nettoyage avant et après l'événement.
    
    *Nettoyage des sols, des murs et des surfaces.
    
    *Désinfection des toilettes et des points de contact.
    
    *Nettoyage des tables et des chaises.
    
    *Vidage des poubelles.
    
    *Enlèvement des déchets.
    
    Bio Cleaners Services est une entreprise fiable et flexible. Nous pouvons adapter nos services à vos besoins spécifiques et à votre budget.
    
    N'hésitez pas à nous contacter pour obtenir un devis gratuit.
    
   -Nettoyage des congrès, conférence, salon professionnel... 
    
   -Nettoyage des cérémonies (mariage,anniv...) 
    
   -Nettoyage après soirée.
    
   -Nettoyage de salles (concert, théâtre, cinéma...) 
    
   -Nettoyage des fêtes d’ouverture.`,
    images: ['/party.webp'] 
    },
  { id: 12, title: 'Traitement des nuisibles',
    description: `Le traitement des nuisibles est essentiel pour assurer un environnement sain et sûr, que ce soit dans des résidences, des bureaux, ou des établissements de santé. Bio Cleaners Services offre des solutions efficaces et respectueuses de l'environnement pour éradiquer les nuisibles tout en minimisant les risques pour la santé humaine.

Nos services incluent :

Inspection et évaluation : Nos experts commencent par une inspection complète des lieux pour identifier les signes de présence de nuisibles, tels que les insectes, les rongeurs, ou les oiseaux. Cette évaluation permet de déterminer la meilleure stratégie de traitement.

Traitements ciblés : Nous utilisons des méthodes adaptées à chaque type de nuisible, qu'il s'agisse de pièges, de répulsifs, ou de traitements chimiques sécurisés. Nos interventions sont conçues pour être discrètes et efficaces, tout en respectant les normes de sécurité et d'hygiène.

Prévention : Au-delà de l'éradication des nuisibles, nous mettons en place des mesures de prévention pour éviter toute réinfestation. Cela inclut le colmatage des accès, l'entretien régulier des espaces sensibles, et des conseils pour maintenir un environnement propre.

Surveillance continue : Nous offrons un service de surveillance pour détecter et traiter rapidement toute nouvelle apparition de nuisibles. Nos équipes interviennent à la demande ou selon un calendrier régulier, en fonction des besoins de nos clients.

Bio Cleaners Services s'engage à fournir :

*Des interventions rapides et efficaces : Nous comprenons l'urgence liée à la présence de nuisibles et intervenons rapidement pour résoudre le problème.

*Des solutions écologiques : Nous privilégions l'utilisation de produits et de méthodes respectueuses de l'environnement pour protéger la santé de nos clients et de leurs animaux domestiques.

*Un suivi personnalisé : Chaque situation est unique. C'est pourquoi nous offrons un suivi personnalisé pour assurer l'efficacité à long terme de nos traitements.

Choisir Bio Cleaners Services pour le traitement des nuisibles, c'est opter pour la tranquillité d'esprit et un environnement exempt de nuisibles.`,
    images: ['/nuisible.jpg', '/nuis.jpg'] 
    },
  { id: 13, title: 'Nettoyage et désinfection de canapés et moquettes:',
    description:  `
    Nous offrons une large gamme de services, notamment :

    *Nettoyage de canapés en tissu ou cuir.
    
    *Nettoyage de fauteuils en tissu ou cuir.
    
    *Nettoyage de banquettes en tissu.
    
    *Nettoyage de chaises rembourrées en tissu.
    
    *Nettoyage de sofas, divans et têtes de lit.
    
    *Nettoyage de sommiers.
    
    *Nettoyage de tout mobilier recouvert de textile.
    
    *Nettoyage de moquettes.
    
    Nos experts sont formés et équipés pour :
    
    -Éliminer les taches et les saletés.
    
    -Désinfecter les surfaces et éliminer les bactéries.
    
    -Rafraîchir les tissus et éliminer les odeurs.
    
    -Prolonger la durée de vie de votre mobilier.
    
    Nous utilisons des produits et des méthodes :
    
    *Efficaces et sans danger pour la santé.
    
    *Respecte l'environnement.
    
    *Adaptés à chaque type de matériaux.

    .Désinfection et assainissement des textiles d'ameublement avec traitement anti-acariens et bactériens (extermination de tiques, puces, punaise de lit...) 
    
    .Traitement en profondeur des mauvaises odeurs des tissus et moquettes (urine, vomi, moisissure, excrément, corporel, animal...) 
    
    .Détachage des tissus et moquettes Pressing et shampouinage de tout type de textile d'ameublement.
    
    .Dépoussiérage minutieux et en profondeur (rideaux, tissus muraux, moquettes...) 
    
    .Traitement anti-tâche des tissus et moquettes (imperméabilisation et protection en profondeur des fibres textiles contre toutes salissures) Nettoyage et traitement des cuirs.
   
    N'hésitez pas à nous contacter pour obtenir un devis gratuit.`,
    images: ['/canapé.jpg', '/canape.jpg'] 
    },
  { id: 14, title: 'Nettoyage des bureaux et locaux administratifs',
    description:  `

   Pour un immeuble de bureaux propre et accueillant, faites confiance à Bio Cleaners Services.
La première impression est souvent la plus importante. C'est pourquoi il est essentiel que votre immeuble de bureaux soit propre et accueillant pour vos clients et vos employés.

Bio Cleaners Services est une entreprise spécialisée dans le nettoyage et l'entretien de bureaux, commerces et tous locaux recevant du public.

Nous offrons une large gamme de services, notamment :

*Nettoyage des sols, murs et plafonds

*Nettoyage des vitres et des moquettes.

*Désinfection des sanitaires et des points de contact.

*Nettoyage des bureaux et des espaces communs.

*Vidage des poubelles.

*Enlèvement des déchets.

*Nettoyage humide des surfaces..

*Dépoussiérage des postes de travail.

*Le nettoyage des toilettes, vestiaires et cuisines. 

*Le passage de l’aspirateur et le nettoyage des sols.

*Le dépoussiérage des surfaces.. 

*Nettoyage de vitrines. 

*Désinfection du matériel informatique... .`,
        
    images: ['/burreau v2.jpg', '/burreau.jpg'] 
    },
  { id: 15, title: 'NETTOYAGE HÔTELS ET RESTAURANTS',
    description:  `
Bio Cleaners Services : Votre partenaire pour un environnement professionnel propre et accueillant.
Le bon entretient et le nettoyage des parties communes de votre établissement sont essentiels pour :

-Attirer et fidéliser votre clientèle.

-Assurer le confort et la sécurité de vos clients et de vos employés.

-Contribuer à la réussite commerciale de votre entreprise.

Bio Cleaners Services est une entreprise spécialisée dans le nettoyage des locaux professionnels, notamment les hôtels et les restaurants.

Nous offrons une large gamme de services, notamment :

.Nettoyage des chambres d'hôtel.

.Entretien des locaux et parties communes.

.Nettoyage des espaces de restauration.

.Nettoyage des vitres.

.Nettoyage des cuisines.

.Désinfection des sanitaires.

Notre équipe est composée d'agents d'entretien expérimentés et formés pour utiliser des techniques de nettoyage éprouvées et des produits professionnels.

Nous nous adaptons à vos besoins et à votre budget pour vous proposer un protocole de nettoyage personnalisé.

Nous mettons en place un suivi régulier des prestations pour vous garantir un entretien sérieux et continu de votre établissement.

*Entretien du bac à graisse du restaurant.

*Nettoyage, dégraissage et désinfection des cuisines .

*Nettoyage de la hotte du restaurant.

*Décapage et traitement des sols (lustrage si nécessaire).

*Cristallisation du marbre.

*Aspiration de moquette voir shampouinage  pour remise en état.

*Dépoussiérage du mobilier.

*Balayage, nettoyage et désinfection des parties communes.

*Entretien régulier de toutes les surfaces (y compris le nettoyage en hauteur)

*Services de nettoyage, désinfection des chambres et des salles de bain.

*Remplacement des consommables des cabinets de toilettes et de la salle de bain.

*Nettoyage des vitres et surfaces vitrées.

*Ramassage des poubelles .`,
    images: ['/restau.jpg', '/hotl.jpg'] 
    },
  { id: 16, title: 'NETTOYAGE DE COMMERCES, MAGASINS',
    description:  `
Bio Cleaners Services propose ses services d'entretien de commerces et tous locaux recevant du public, comme le centre commercial.

Nous intervenons dans la région de Agadir , Marrakech et Casablanca 7j/7.

La prestation d'entretient des commerces peut inclure:

*Nettoyage des sols, murs et plafonds.

*Nettoyage des vitres et des moquettes.

*Désinfection des sanitaires et des points de contact.

*Nettoyage des bureaux et des espaces communs.

*Enlèvement des déchets.

*Nettoyage des vitrines. 

*Nettoyage humides des surfaces.

*Dépoussiérage .

*Remise en rayon.

Et plus encore!

Notre équipe est composée d'agents d'entretien expérimentés et formés pour utiliser des techniques de nettoyage éprouvées et des produits professionnels.

Nous nous adaptons à vos besoins et à votre budget pour vous proposer un programme d'entretien personnalisé.

Nous mettons en place un suivi régulier des prestations pour vous garantir un entretien sérieux et continu de votre établissement.`,
    images: ['/commerce.jpg'] 
    },

];

const ServiceDetail = () => {
  const { id } = useParams();
  const service = services.find(service => service.id === parseInt(id));

  if (!service) return <div>Service non trouvé</div>;

  return (
    <div className="service-detail-container">
      <ImageSlider images={service.images} />
      <div className="service-detail-content">
        <h1>{service.title}</h1>
        <p>{service.description}</p>
        <a href="/Book" className="service-link">Obtenir le service</a>
        {/* Ajoutez d'autres éléments ici */}
      </div>
    </div>
  );
};

export default ServiceDetail;
